import Vue from 'vue';
import App from './App';
import { router } from '@/router';
import store from '@/store';
// import VueAMap from 'vue-amap'
Vue.prototype.$store=store.state.auth
import UUID from 'vue-uuid'
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import {Dialog,Notify,Toast} from 'vant';
import { init } from "./init";
// import VConsole from '../static/vconsole.min.js'
// new VConsole();

Vue.prototype.$dialog=Dialog
Vue.prototype.$notify=Notify
Vue.prototype.$toast=Toast
// 引入全局样式
import '@/assets/css/iconfont.css'
// import './style/reset.less'
import "./style/index.less";
//引入
// import echarts from 'echarts'

// Vue.prototype.$echarts = echarts

// 全局注册
Vue.use(UUID)
init({ router }).then(()=>{
  new Vue({
    el: '#app',
    router,
    render: h => h(App)
  });
})
